import { render, staticRenderFns } from "./WarehouseConfigSelector.vue?vue&type=template&id=a9512b24"
import script from "./WarehouseConfigSelector.vue?vue&type=script&lang=js"
export * from "./WarehouseConfigSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports